export const containers = [
  {
    type: "20st",
    name: "20' STANDARD",
    insideLength: "5.895 m",
    insideWidth: "2.350 m",
    insideHeight: "2.392 m",
    doorWidth: "2.340 m",
    doorHeight: "2.292 m",
    capacity: "33 m3",
    tareWeight: "2230 Kgs",
    maxWeight: "28230 Kgs",
    disabled: false,
    description: [
      "Standard containers are also known as general purpose containers.",
      "They are closed containers, i.e. they are closed on all sides. A distinction may be drawn between the following types of standard container:",
      [
        "Standard containers with doors at one or both end(s)",
        "Standard containers with doors at one or both end(s) and doors over the entire length of one or both sides",
        "Standard containers with doors at one or both end(s) and doors on one or both sides",
      ],
      "In addition, the various types of standard container also differ in dimensions and weight, resulting in a wide range of standard containers.",
      "Standard containers are mainly used as 20' and 40' containers. Containers with smaller dimensions are very seldom used. Indeed, the trend is towards even longer dimensions, e.g. 45'.",
    ],
  },
  {
    type: "40st",
    name: "40' STANDARD",
    insideLength: "12.029 m",
    insideWidth: "2.350 m",
    insideHeight: "2.392 m",
    doorWidth: "2.340 m",
    doorHeight: "2.292 m",
    capacity: "67 m3",
    tareWeight: "3780 Kgs",
    maxWeight: "26700 Kgs",
    disabled: false,
    description: [
      "Standard containers are also known as general purpose containers.",
      "They are closed containers, i.e. they are closed on all sides. A distinction may be drawn between the following types of standard container:",
      [
        "Standard containers with doors at one or both end(s)",
        "Standard containers with doors at one or both end(s) and doors over the entire length of one or both sides",
        "Standard containers with doors at one or both end(s) and doors on one or both sides",
      ],
      "In addition, the various types of standard container also differ in dimensions and weight, resulting in a wide range of standard containers.",
      "Standard containers are mainly used as 20' and 40' containers. Containers with smaller dimensions are very seldom used. Indeed, the trend is towards even longer dimensions, e.g. 45'.",
    ],
  },
  {
    type: "40hq",
    name: "40' HIGH-CUBE",
    insideLength: "12.024 m",
    insideWidth: "2.350 m",
    insideHeight: "2.697 m",
    doorWidth: "2.340 m",
    doorHeight: "2.597 m",
    capacity: "76 m3",
    tareWeight: "4020 Kgs",
    maxWeight: "26460 Kgs",
    disabled: false,
    description: [
      "High-cube containers are similar in structure to standard containers, but taller. In contrast to standard containers, which have a maximum height of 2591 mm (8'6\"), high-cube containers are 2896 mm, or 9'6\", tall. High-cube containers are for the most part 40' long, but are sometimes made as 45' containers.",
      "A number of lashing rings, capable of bearing loads of at most 1000 kg, are mounted on the front top end rail and bottom cross member and the corner posts.",
      "Many 40' containers have a recess in the floor at the front end which serves to center the containers on so-called gooseneck chassis. These recesses allow the containers to lie lower and therefore to be of taller construction.",
    ],
  },
  {
    type: "45hq",
    name: "45' HIGH-CUBE",
    insideLength: "13.556 m",
    insideWidth: "2.352 m",
    insideHeight: "2.700 m",
    doorWidth: "2.340 m",
    doorHeight: "2.597 m",
    capacity: "86 m3",
    tareWeight: "4800 Kgs",
    maxWeight: "27700 Kgs",
    disabled: false,
    description: [
      "High-cube containers are similar in structure to standard containers, but taller. In contrast to standard containers, which have a maximum height of 2591 mm (8'6\"), high-cube containers are 2896 mm, or 9'6\", tall. High-cube containers are for the most part 40' long, but are sometimes made as 45' containers.",
      "A number of lashing rings, capable of bearing loads of at most 1000 kg, are mounted on the front top end rail and bottom cross member and the corner posts.",
      "Many 40' containers have a recess in the floor at the front end which serves to center the containers on so-called gooseneck chassis. These recesses allow the containers to lie lower and therefore to be of taller construction.",
    ],
  },
  {
    type: "20op",
    name: "20' OPEN TOP",
    insideLength: "5.888 m",
    insideWidth: "2.345 m",
    insideHeight: "2.315 m",
    doorWidth: "2.286 m",
    doorHeight: "2.184 m",
    capacity: "32 m3",
    tareWeight: "2250 Kgs",
    maxWeight: "30480 Kgs",
    description: [
      "The walls of open-top containers are generally made of corrugated steel. The floor is made of wood.",
      "It has the following typical distinguishing structural features. The roof consists of removable bows and a removable tarpaulin. The door header may be swivelled out.",
      "These two structural features greatly simplify the process of packing and unpacking the container. In particular, it is very easy to pack and unpack the container from above or through the doors by crane or crab when the roof is open and the door header is swivelled out.",
      "It should be noted, however, that the purpose of the roof bows of an open-top container is not solely to support the tarpaulin but also to contribute to container stability. Flatracks are therefore more suitable for overheight cargoes.",
      "Lashing rings, to which the cargo may be secured, are installed in the upper and lower side rails and the corner posts. The lashing rings may take loads of up to 1,000 kg.",
    ],
  },
  {
    type: "40op",
    name: "40' OPEN TOP",
    insideLength: "12.029 m",
    insideWidth: "2.342 m",
    insideHeight: "2.326 m",
    doorWidth: "2.341 m",
    doorHeight: "2.274 m",
    capacity: "65 m3",
    tareWeight: "3810 Kgs",
    maxWeight: "26670 Kgs",
    description: [
      "The walls of open-top containers are generally made of corrugated steel. The floor is made of wood.",
      "It has the following typical distinguishing structural features. The roof consists of removable bows and a removable tarpaulin. The door header may be swivelled out.",
      "These two structural features greatly simplify the process of packing and unpacking the container. In particular, it is very easy to pack and unpack the container from above or through the doors by crane or crab when the roof is open and the door header is swivelled out.",
      "It should be noted, however, that the purpose of the roof bows of an open-top container is not solely to support the tarpaulin but also to contribute to container stability. Flatracks are therefore more suitable for overheight cargoes.",
      "Lashing rings, to which the cargo may be secured, are installed in the upper and lower side rails and the corner posts. The lashing rings may take loads of up to 1,000 kg.",
    ],
  },
  {
    type: "20ft",
    name: "20' FLATRACK",
    insideLength: "5.698 m",
    insideWidth: "2.230 m",
    insideHeight: "2.255 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "2500 Kgs",
    maxWeight: "21500 Kgs",
    disabled: true,
    description: [
      "Flatracks consist of a floor structure with a high loading capacity composed of a steel frame and a softwood floor and two end walls, which may either be fixed or collapsible. The end walls are stable enough to allow cargo securing means to be attached and several flatracks to be stacked on top of one another. Flatracks are available in 20' and 40' sizes.",
      "A number of lashing rings, to which the cargo may be secured, are installed in the side rails, the corner posts and the floor. The lashing rings may take loads of up to 2000 kg in the case of 20' flatracks or up to 4000 kg in the case of 40' flatracks.",
      "Some types of 20' flatracks have forklift pockets.",
      "40' flatracks have gooseneck tunnels at each end. In addition, they are sometimes equipped with lashing winches with 2 metric ton lashing belts.",
      "For transport of certain cargoes, flatracks may be provided with stanchions",
    ],
  },
  {
    type: "40ft",
    name: "40' FLATRACK",
    insideLength: "11.832 m",
    insideWidth: "2.228 m",
    insideHeight: "1.981 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "4200 Kgs",
    maxWeight: "40800 Kgs",
    disabled: true,
    description: [
      "Flatracks consist of a floor structure with a high loading capacity composed of a steel frame and a softwood floor and two end walls, which may either be fixed or collapsible. The end walls are stable enough to allow cargo securing means to be attached and several flatracks to be stacked on top of one another. Flatracks are available in 20' and 40' sizes.",
      "A number of lashing rings, to which the cargo may be secured, are installed in the side rails, the corner posts and the floor. The lashing rings may take loads of up to 2000 kg in the case of 20' flatracks or up to 4000 kg in the case of 40' flatracks.",
      "Some types of 20' flatracks have forklift pockets.",
      "40' flatracks have gooseneck tunnels at each end. In addition, they are sometimes equipped with lashing winches with 2 metric ton lashing belts.",
      "For transport of certain cargoes, flatracks may be provided with stanchions",
    ],
  },
  {
    type: "20fc",
    name: "20' FLATRACK COLLAPSIBLE",
    insideLength: "5.675 m",
    insideWidth: "2.213 m",
    insideHeight: "2.270 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "2600 Kgs",
    maxWeight: "30150 Kgs",
    disabled: true,
    description: [
      "Flatracks consist of a floor structure with a high loading capacity composed of a steel frame and a softwood floor and two end walls, which may either be fixed or collapsible. The end walls are stable enough to allow cargo securing means to be attached and several flatracks to be stacked on top of one another. Flatracks are available in 20' and 40' sizes.",
      "A number of lashing rings, to which the cargo may be secured, are installed in the side rails, the corner posts and the floor. The lashing rings may take loads of up to 2000 kg in the case of 20' flatracks or up to 4000 kg in the case of 40' flatracks.",
      "Some types of 20' flatracks have forklift pockets.",
      "40' flatracks have gooseneck tunnels at each end. In addition, they are sometimes equipped with lashing winches with 2 metric ton lashing belts.",
      "For transport of certain cargoes, flatracks may be provided with stanchions",
    ],
  },
  {
    type: "40fc",
    name: "40' FLATRACK COLLAPSIBLE",
    insideLength: "11.660 m",
    insideWidth: "2.200 m",
    insideHeight: "2.245 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "5700 Kgs",
    maxWeight: "39300 Kgs",
    disabled: true,
    description: [
      "Flatracks consist of a floor structure with a high loading capacity composed of a steel frame and a softwood floor and two end walls, which may either be fixed or collapsible. The end walls are stable enough to allow cargo securing means to be attached and several flatracks to be stacked on top of one another. Flatracks are available in 20' and 40' sizes.",
      "A number of lashing rings, to which the cargo may be secured, are installed in the side rails, the corner posts and the floor. The lashing rings may take loads of up to 2000 kg in the case of 20' flatracks or up to 4000 kg in the case of 40' flatracks.",
      "Some types of 20' flatracks have forklift pockets.",
      "40' flatracks have gooseneck tunnels at each end. In addition, they are sometimes equipped with lashing winches with 2 metric ton lashing belts.",
      "For transport of certain cargoes, flatracks may be provided with stanchions",
    ],
  },
  {
    type: "20p",
    name: "20' PLATFORM",
    insideLength: "6.058 m",
    insideWidth: "2.438 m",
    insideHeight: "0.370 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "2520 Kgs",
    maxWeight: "27960 Kgs",
    disabled: true,
    description: [
      "Platforms consist solely of a floor structure with extremely high loading capacity; they have no side or end walls. This high loading capacity makes it possible to concentrate heavy weights on small areas. A platform consists of a steel frame and a wooden floor structure.",
      "Platforms are available in 20' and 40' sizes. 40' platforms have a gooseneck tunnel at each end.",
      "Lashing rings, to which the cargo may be secured, are installed in the side rails. The lashing rings may take loads of up to 3.000 kg.",
    ],
  },
  {
    type: "40p",
    name: "40' PLATFORM",
    insideLength: "12.192 m",
    insideWidth: "2.245 m",
    insideHeight: "0.648 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "5700 Kgs",
    maxWeight: "39300 Kgs",
    disabled: true,
    description: [
      "Platforms consist solely of a floor structure with extremely high loading capacity; they have no side or end walls. This high loading capacity makes it possible to concentrate heavy weights on small areas. A platform consists of a steel frame and a wooden floor structure.",
      "Platforms are available in 20' and 40' sizes. 40' platforms have a gooseneck tunnel at each end.",
      "Lashing rings, to which the cargo may be secured, are installed in the side rails. The lashing rings may take loads of up to 3.000 kg.",
    ],
  },
  {
    type: "20ref",
    name: "20' REFRIGERATED",
    insideLength: "5.724 m",
    insideWidth: "2.286 m",
    insideHeight: "2.014 m",
    doorWidth: "2.286 m",
    doorHeight: "2.067 m",
    capacity: "26 m3",
    tareWeight: "2550 Kgs",
    maxWeight: "21450 Kgs",
    disabled: false,
    description: [
      "The refrigeration unit is arranged in such a way that the external dimensions of the container meet ISO standards and thus fit into the container ship cell guides, for example. The presence of an integral refrigeration unit entails a loss of internal volume and payload.",
      "When being transported by ship, integral units have to be connected to the on-board power supply system. The number of refrigerated containers which may be connected depends on the capacity of the ship's power supply system. If the aforesaid capacity is too low for the refrigerated containers to be transported, \"power packs\" may be used, which are equipped with relatively large diesel generators and satisfy ISO requirements with regard to the dimensions of a 20' container. When at the terminal, the containers are connected to the terminal's power supply system. For transport by road and rail, most integral unit refrigeration units are operated by a generator set (genset). This may either be a component of the refrigeration unit or connected to the refrigeration unit.",
      'Air flows through the container from bottom to top. In general, the "warm" air is drawn off from the inside of the container, cooled in the refrigeration unit and then blown back in the container as cold air.',
      "In the upper area of the container, adequate space (at least 12 cm) must likewise be provided for air flow. For this purpose, during packing of the container adequate free space must be left above the cargo. The maximum load height is marked on the side walls.",
      "To ensure vertical air flow from bottom to top, packaging must also be appropriately designed and the cargo must be sensibly stowed.",
      "In addition to temperature regulation, integral units also allow a controlled fresh air exchange, for example for the removal of metabolic products such as CO2 and ethylene in the case of the transport of fruits.",
      "In the refrigeration units, both the supply and return air temperatures are measured and, depending on the operating mode, one of these values is used to control the cold air. Temperature measurement may be performed in various ways. The Partlow recorder generally records return air temperature, since this provides an indication of the state or temperature of the cargo. Data loggers are increasingly used, which detect temperature digitally and indicate it on a display. Once transferred to a PC, the data may then be evaluated.",
      "The temperature display is attached to the outside of the refrigeration unit, so that operation of the unit may be checked at any time.",
      "Digital or analog recorders may also be positioned directly in the cargo, so as to measure temperatures inside the container. The recorder should be accommodated in such a way that it records the temperatures at risk points in the container (inside the packaging, top layer at door end).",
      "Integral units may be stowed both above and below deck on a ship. Above deck stowage has the advantage that the heat from return air may be more readily dissipated. However, the containers are often exposed to strong solar radiation, leading to increased refrigeration capacity requirements.",
      "Refrigerated containers are used for goods which need to be transported at a constant temperature above or below freezing point. These goods are divided into chilled goods and frozen goods, depending on the specified transport temperature. They principally include fruit, vegetables, meat and dairy products, such as butter and cheese.",
      "High-cube integral units are used in particular for voluminous and light goods (e.g. fruit, flowers).",
      "Nowadays, goods requiring refrigeration are mostly transported in integral units, which have a markedly higher market share than porthole containers.",
      "Chilled meat is sometimes also transported hanging, for which purpose the ceilings of refrigerated containers are equipped with special hook rails",
    ],
  },
  {
    type: "40ref",
    name: "40' REFRIGERATED",
    insideLength: "11.840 m",
    insideWidth: "2.286 m",
    insideHeight: "2.120 m",
    doorWidth: "2.286 m",
    doorHeight: "2.195 m",
    capacity: "60 m3",
    tareWeight: "3850 Kgs",
    maxWeight: "26630 Kgs",
    disabled: false,
    description: [
      "The refrigeration unit is arranged in such a way that the external dimensions of the container meet ISO standards and thus fit into the container ship cell guides, for example. The presence of an integral refrigeration unit entails a loss of internal volume and payload.",
      "When being transported by ship, integral units have to be connected to the on-board power supply system. The number of refrigerated containers which may be connected depends on the capacity of the ship's power supply system. If the aforesaid capacity is too low for the refrigerated containers to be transported, \"power packs\" may be used, which are equipped with relatively large diesel generators and satisfy ISO requirements with regard to the dimensions of a 20' container. When at the terminal, the containers are connected to the terminal's power supply system. For transport by road and rail, most integral unit refrigeration units are operated by a generator set (genset). This may either be a component of the refrigeration unit or connected to the refrigeration unit.",
      'Air flows through the container from bottom to top. In general, the "warm" air is drawn off from the inside of the container, cooled in the refrigeration unit and then blown back in the container as cold air.',
      "In the upper area of the container, adequate space (at least 12 cm) must likewise be provided for air flow. For this purpose, during packing of the container adequate free space must be left above the cargo. The maximum load height is marked on the side walls.",
      "To ensure vertical air flow from bottom to top, packaging must also be appropriately designed and the cargo must be sensibly stowed.",
      "In addition to temperature regulation, integral units also allow a controlled fresh air exchange, for example for the removal of metabolic products such as CO2 and ethylene in the case of the transport of fruits.",
      "In the refrigeration units, both the supply and return air temperatures are measured and, depending on the operating mode, one of these values is used to control the cold air. Temperature measurement may be performed in various ways. The Partlow recorder generally records return air temperature, since this provides an indication of the state or temperature of the cargo. Data loggers are increasingly used, which detect temperature digitally and indicate it on a display. Once transferred to a PC, the data may then be evaluated.",
      "The temperature display is attached to the outside of the refrigeration unit, so that operation of the unit may be checked at any time.",
      "Digital or analog recorders may also be positioned directly in the cargo, so as to measure temperatures inside the container. The recorder should be accommodated in such a way that it records the temperatures at risk points in the container (inside the packaging, top layer at door end).",
      "Integral units may be stowed both above and below deck on a ship. Above deck stowage has the advantage that the heat from return air may be more readily dissipated. However, the containers are often exposed to strong solar radiation, leading to increased refrigeration capacity requirements.",
      "Refrigerated containers are used for goods which need to be transported at a constant temperature above or below freezing point. These goods are divided into chilled goods and frozen goods, depending on the specified transport temperature. They principally include fruit, vegetables, meat and dairy products, such as butter and cheese.",
      "High-cube integral units are used in particular for voluminous and light goods (e.g. fruit, flowers).",
      "Nowadays, goods requiring refrigeration are mostly transported in integral units, which have a markedly higher market share than porthole containers.",
      "Chilled meat is sometimes also transported hanging, for which purpose the ceilings of refrigerated containers are equipped with special hook rails",
    ],
  },
  {
    type: "20bulk",
    name: "20' BULK",
    insideLength: "5.934 m",
    insideWidth: "2.358 m",
    insideHeight: "2.340 m",
    doorWidth: "2.335 m",
    doorHeight: "2.292 m",
    capacity: "32 m3",
    tareWeight: "2450 Kgs",
    maxWeight: "21550 Kgs",
    disabled: true,
    description: [
      "Bulk (or bulk cargo) containers have three loading hatches in the roof, each of a diameter of approx. 455 mm (1 3/4'). The distance between the hatches (center to center) is 1.83 m (6'). On the door side, there are two discharge hatches, which are sometimes equipped with short discharge tubes for guiding the bulk cargo. Alternatively, two unloading hatches may be mounted in the doorways, for emptying the containers.",
      "Such containers may also be used for general cargo. Lashing rings are mounted in the top side rails for securing the cargo. Some bulk containers are equipped with forklift pockets, which allow handling by forklift trucks.",
      "Bulk containers are used in particular for transporting bulk cargo, such as grain, feedstuffs, spices. However, they may also be used for transporting general cargo.",
    ],
  },
  {
    type: "20tank",
    name: "20' TANK",
    insideLength: "6.058 m",
    insideWidth: "2.438 m",
    insideHeight: "2.438 m",
    doorWidth: "0.000 m",
    doorHeight: "0.000 m",
    capacity: "0 m3",
    tareWeight: "4190 Kgs",
    maxWeight: "26290 Kgs",
    disabled: true,
    description: [
      "Tank containers must be at least 80%% full, to prevent dangerous surging of the liquids in transit. On the other hand, they must not as a rule be over 95%% full, or there will not be sufficient ullage space for thermal expansion. The extent of thermal expansion may be calculated for each cargo on the basis of the following formula:",
      ["ΔV = Va · γ · ΔT", "Ve = Va (1 + γ · ΔT)"],
      "Some hazardous materials must be transported in tank containers with no in- or outlet openings below the surface of the liquid.",
      "Tank containers are generally designed for an operating pressure of up to 3 bar (above atmospheric). The test pressure used is 4.5 bar (above atmospheric).",
    ],
  },
  // {
  //   type: 'LD-1',
  //   name: 'LD-1',
  //   insideLength: '5.895 m',
  //   insideWidth: '2.350 m',
  //   insideHeight: '2.392 m',
  //   maxWeight: '28230 Kgs',
  //   disabled: false,
  //   description: [],
  // },
  // {
  //   type: 'LD-29',
  //   name: 'LD-29',
  //   insideLength: '5.895 m',
  //   insideWidth: '2.350 m',
  //   insideHeight: '2.392 m',
  //   maxWeight: '28230 Kgs',
  //   disabled: false,
  //   description: [],
  // },
  // {
  //   type: 'Demi',
  //   name: 'Demi',
  //   insideLength: '5.895 m',
  //   insideWidth: '2.350 m',
  //   insideHeight: '2.392 m',
  //   maxWeight: '28230 Kgs',
  //   disabled: false,
  //   description: [],
  // },
  {
    type: "custom",
    name: "Custom container",
    insideLength: "5.895 m",
    insideWidth: "2.350 m",
    insideHeight: "2.392 m",
    doorWidth: "2.340 m",
    doorHeight: "2.292 m",
    capacity: "33 m3",
    tareWeight: "2230 Kgs",
    maxWeight: "28230 Kgs",
    disabled: false,
    description: ["Standard container"],
  },
];
